export enum Doc {
  AA = 'aa',
  ACH = 'ach',
  BAPN = 'bapn',
  CIP = 'cip',
  CPA = 'cpa',
  CSD = 'csd',
  DCD = 'dcd',
  ESIGN = 'esign',
  ICC = 'icc',
  PP = 'pp',
  PS = 'ps',
  TIL = 'til',
  TOS = 'tos',
  WD = 'wd',
  DRD = 'drd',
}
